<footer>
    <div class="vincent_container">
        <div class="row">
            <div class="col col-12">
                <div class="vincent_logo_cont">
                    <a href="index.html" class="">
                        <img src="assets/imgs/logo.png" alt="بيوتي" style="width: 100px;">
                    </a>
                </div>
                <div class="vincent_copy_text">Copyright © 2020 MBN. All Rights Reserved.</div>
            </div>
        </div>
    </div>
</footer>